import React, {useEffect} from 'react';
import {useNavigate} from 'react-router';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {AppAnon} from '../../../app/AppAnon';

type Props = NoProps;

export const LogoutCallback: React.FC<Props> = () => {
  const navigate = useNavigate();
  const {authState, logoutCallback} = useAuthState();
  const {t} = useLocalization();

  useEffect(() => {
    logoutCallback();

    if (authState?.status !== 'Authenticated') {
      navigate('/login');
    }
  }, [authState?.status, navigate, logoutCallback]);

  return <AppAnon>{t('page.login.redirect')}</AppAnon>;
};
